export default "__VITE_ASSET__gDtThjap__"